
import React from 'react'
import { useSelector } from 'react-redux'

export const useGetLineItemsbyInvoiceId=(invoiceId)=>(useSelector((state) => state.InvoicesReducer.lineItems[invoiceId]) || [])